const initialState = {
  bookingHistory: [],
  recentlyCreated: [],
  upcomingBookings: [],
  webId: null,
  activeTab: 'history',
  lastUpdateTs: null,
};

export default function domesticViewBookingReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case 'SET_DOMESTIC_VIEW_BOOKING_RESULT':
      return {
        ...state,
        ...action.payload,
        lastUpdateTs: new Date(),
      };
    case 'SET_DOMESTIC_VIEW_BOOKING_TAB':
      return { ...state, activeTab: action.payload };
    case 'RESET_DOMESTIC_VIEW_BOOKING':
      return initialState;
    default:
      return state;
  }
}
